import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Capacitor } from '@capacitor/core'
import { AuthProvider } from './auth/AuthProvider'
import './styles.css'

async function start() {
  const isArcadeApp = Capacitor.isNativePlatform() || import.meta.env.VITE_YBG_ARCADE_APP === 'true'
  const RootApp = isArcadeApp
    ? (await import('./mobile/ArcadeMobileApp')).default
    : (await import('./App')).default

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AuthProvider>
        <RootApp />
      </AuthProvider>
    </StrictMode>,
  )
}

void start()

if (
  !Capacitor.isNativePlatform() &&
  import.meta.env.VITE_YBG_ARCADE_APP !== 'true' &&
  'serviceWorker' in navigator &&
  import.meta.env.PROD
) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
